module.exports = __webpack_public_path__ + "img/parks.5514ed77.svg";